const shipmentInfoTypeEnum = {
	shipment: 1,
	return: 2,
};

const shipmentInfoStatusEnum = {
	voided: 0,
	active: 1,
};

export { shipmentInfoTypeEnum, shipmentInfoStatusEnum };



// WEBPACK FOOTER //
// ./src/common/constants/shipmentInfoEnums.js